// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environments.prod.ts`.

export const environment = {
  environment: 'dev',
  appVersion: process.env['NX_PUBLIC_APP_VERSION'],
  defaultRedirectUri: 'https://dev.delivery-platform.spins.team/loginCallback',
  ixOneRegistrationRedirectUri:
    'https://dev.delivery-platform.spins.team/settings/subscriptions?registration=ix-one',
  recaptchaSiteKey: process.env['NX_PUBLIC_RECAPTCHA_SITE_KEY'],
};
